@if (nodes().length === 0) {
  <div class="empty" i18n="@@einvoice.model-tree.no-provenance">No provenance data available.</div>
} @else {
  <nav class="model-tree" aria-label="EN16931 logical model" i18n-aria-label="@@einvoice.model-tree.aria-label">
    <ng-container *ngTemplateOutlet="treeNodes; context: { $implicit: nodes() }"></ng-container>
  </nav>
}

<ng-template #treeNodes let-nodes>
  @for (node of nodes; track node.id) {
    @if (node.children.length > 0) {
      <details class="tree-group" open>
        <summary
          [attr.data-search-id]="node.id"
          [class.search-match]="searchResultIds().has(node.id)"
          [class.current-search-match]="node.id === currentSearchResultId()"
          [style.padding-left.px]="12 + node.depth * 18"
          [attr.title]="node.tooltip">
          <span class="twisty" aria-hidden="true"></span>
          @if (node.code) {
            <span class="term term--group">{{node.code}}</span>
          }
          <span class="label">{{node.label}}</span>
          @if (node.context) {
            <span class="context">{{node.context}}</span>
          }
        </summary>
        <ng-container *ngTemplateOutlet="treeNodes; context: { $implicit: node.children }"></ng-container>
      </details>
    } @else {
      <div class="tree-leaf-row"
        [attr.data-search-id]="node.id"
        [class.selected]="!!node.entry?.modelPath && selectedModelPaths().has(node.entry!.modelPath)"
        [class.active]="node.entry?.modelPath === activeModelPath()"
        [class.search-match]="searchResultIds().has(node.id)"
        [class.current-search-match]="node.id === currentSearchResultId()">
        <button type="button" class="tree-leaf" [attr.data-model-path]="node.entry?.modelPath" [style.padding-left.px]="30 + node.depth * 18" [attr.title]="node.tooltip" (click)="select(node.entry, $event)">
          @if (node.code) {
            <span class="term">{{node.code}}</span>
          }
          <span class="label">{{node.label}}</span>
          @if (node.entry?.valuePreview) {
            <span class="value">{{node.entry?.valuePreview}}</span>
          }
        </button>
        @if (node.entry?.valuePreview) {
          <button type="button" class="copy-value" [class.copied]="node.entry?.modelPath === copiedModelPathValue()" (click)="copyValue(node.entry, $event)" i18n-title="@@einvoice.model-tree.copy-value" title="Copy value">
            <span class="copy-value__default" i18n="@@einvoice.model-tree.copy">Copy</span>
            <span class="copy-value__done" aria-hidden="true">✓</span>
          </button>
        }
      </div>
    }
  }
</ng-template>